import { render, staticRenderFns } from "./ComboTipoLead.vue?vue&type=template&id=49232eae"
import script from "./ComboTipoLead.vue?vue&type=script&lang=ts"
export * from "./ComboTipoLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports